<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										Details Receipt and Payments - CUA
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :title="'RECEIPT & PAYMENTS - CUA'" :form="form"
										@filterAction="filterAction" :filter="filter"></report-filter>
									<b-button @click="printPDF" class="me-2 btn-sm akkurate-green-btn akkurate-small"
										title="Print"><font-awesome-icon :icon="['fas', 'print']" /></b-button>
									<b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small"
										title="Download"><font-awesome-icon :icon="['fas', 'download']" /></b-button>
								</div>
							</div>
						</div>
						<div class="card-body mx-3" ref="pdfContent">
							<div class="row">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution" :current_date="false"
										:title="'NOTE TO RECEIPTS & PAYMENTS - CUA'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list_display }}
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-8"></div>
								<div class="col-md-4 text-end">
									<div>
										Terms:
										<span class="fw-bold">{{
											form.terms
										}}</span>
									</div>
									<span class="mt-2">From:
										<strong>{{ form.start_date }}</strong>
										To: <strong>{{ form.end_date }}</strong>
									</span>
								</div>
							</div>
							<div v-if="isBusy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
							<div v-else id="balance-sheet" class="row">
								<div class="col-12 my-2"></div>
								<div class="col-6 col-md-6 px-0 trans_details">
									<b-table-simple responsive outlined bordered>
										<b-thead>
											<b-tr>
												<b-th class="text-center fs-6 akkurate-green"
													colspan="3"><span>RECEIPTS</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr>
												<td class="py-0 px-2">
													Beg. of the month cash
												</td>
												<td class="py-0 px-2">
													GHS
													{{
														displayNumber(
															Number(
																beg_of_month_cash
															).toFixed(2)
														)
													}}
												</td>
											</b-tr>
											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														MEMBER SHARES DEPOSIT
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(value, item) in member_shares.data"
												:key="value.id + 'member_share_dp'" class="list-item">
												<b-td>
													{{ value.name }} - ({{ value.coabranch?.name }})
												</b-td>
												<b-td>
													GHS
													{{ displayNumber(value.coasubheadstransactions?.[0]?.cr_balance) ??
														0 }}
												</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="success" style="font-weight: bold">
													Total Shares Deposit
												</b-td>
												<b-td variant="success" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_shares_dp
														)
													}}
												</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="secondary" colspan="2" style="font-weight: bold">
													<p class="m-0">
														MEMBER SAVINGS DEPOSIT
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in member_savings.data" :key="value.id +
													'member_savings_dp'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.cr_balance
														) ?? 0
													}}</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="success" style="font-weight: bold">
													Total Savings Deposit
												</b-td>
												<b-td variant="success" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_savings_dp
														)
													}}
												</b-td>
											</b-tr>
											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														LOAN REPAYMENT
													</p>
												</b-td>
											</b-tr>

											<b-tr v-for="(
													value, item
												) in member_loans.data" :key="value.id + 'loan_repayment'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.cr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="success" style="font-weight: bold">
													Total Loan Repayment
												</b-td>
												<b-td variant="success" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_loan_repayment
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														BANK SAVINGS WITHDRWALS
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in bank_savings.data" :key="value.id + 'banlk_savings'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.cr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="success" style="font-weight: bold">
													Total Bank Savings
													Withdrawals
												</b-td>
												<b-td variant="success" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_bank_savings_wd
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														BANK CURRENT WITHDRWALS
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in bank_currents.data" :key="value.id" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.cr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="success" style="font-weight: bold">
													Total Bank Current
													Withdrawals
												</b-td>
												<b-td variant="success" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_bank_current_wd
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													CUA/CFF/ WITHDRAWALS
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in cff.data" :key="value.id +
													'cua_cff_withdrawals'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.cr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="success" style="font-weight: bold">
													Total CUA/CFF Withdrawals
												</b-td>
												<b-td variant="success" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_cff_wd
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														T-BILLS DISCOUNT
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in t_bills.data" :key="value.id + 't_bill_discount'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.cr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="success" style="font-weight: bold">
													Total T-Bill Discount
												</b-td>
												<b-td variant="success" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_t_bill_discount
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													OTHER RECEIPTS
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in others.data" :key="value.id + 'other_receipts'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.cr_balance
														) ?? 0
													}}</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="success" style="font-weight: bold">
													Total Other Receipts
												</b-td>
												<b-td variant="success" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_other_receipt
														)
													}}
												</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="secondary" style="font-weight: bold">
													Sub- Total for the Month
												</b-td>
												<b-td variant="secondary" style="font-weight: bold">GHS
													{{
														displayNumber(
															sub_total_receipt
														)
													}}</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="secondary" style="font-weight: bold">
													Income for the month
												</b-td>
												<b-td variant="secondary" style="font-weight: bold">GHS
													{{
														displayNumber(
															monthly_income
														)
													}}</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="secondary" style="font-weight: bold">
													Total Receipts
												</b-td>
												<b-td variant="secondary" style="font-weight: bold">GHS
													{{
														displayNumber(
															Number(
																grand_total_receipt
															)
														)
													}}</b-td>
											</b-tr>
										</b-tbody>
									</b-table-simple>
								</div>
								<div class="col-6 col-md-6 px-0 trans_details">
									<b-table-simple responsive outlined bordered>
										<b-thead>
											<b-tr>
												<b-th class="text-center fs-6 akkurate-green"
													colspan="3"><span>PAYMENTS</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr>
												<td class="py-0 px-2">
													End. of the month cash
												</td>
												<td class="py-0 px-2">
													GHS
													{{
														displayNumber(
															Number(
																end_of_month_cash
															).toFixed(2)
														)
													}}
												</td>
											</b-tr>
											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													MEMBER SHARES WITHDRAWALS
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in member_shares.data" :key="value.id + 'member_share_wd'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{ value.coabranch?.name }})
												</b-td>
												<b-td>
													GHS
													{{
														displayNumber(value.coasubheadstransactions?.[0]?.dr_balance) ?? 0
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="danger" style="font-weight: bold">
													Total Shares Withdrawals
												</b-td>
												<b-td variant="danger" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_shares_with
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													MEMBER SAVING WITHDRAWALS
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in member_savings.data" :key="value.id +
													'member_saving_wd'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.dr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="danger" style="font-weight: bold">
													Total Savings Withdrawals
												</b-td>
												<b-td variant="danger" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_savings_with
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														LOANS TO MEMBERS
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in member_loans.data" :key="value.id + 'loan_to_members'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.dr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="danger" style="font-weight: bold">
													Total Loans to members
												</b-td>
												<b-td variant="danger" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_loan_disbursed
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														BANK SAVINGS DEPOSIT
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in bank_savings.data" :key="value.id + 'bank_savings_dp'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})
												</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.dr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="danger" style="font-weight: bold">
													Total Bank Saving
												</b-td>
												<b-td variant="danger" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_bank_savings_dp
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													BANK CURRENT DEPOSIT
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in bank_currents.data" :key="value.id + 'bank_current_dp'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.dr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="danger" style="font-weight: bold">
													Total Bank Current
												</b-td>
												<b-td variant="danger" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_bank_current_dp
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														CUA/CFF DEPOSITS
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in cff.data" :key="value.id + 'cau_cff_dp'" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.dr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="danger" style="font-weight: bold">
													Total CUA/CFF Deposit
												</b-td>
												<b-td variant="danger" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_cff_dp
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													<p class="m-0">
														T-BILLS INVEST
													</p>
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in t_bills.data" :key="value.id + 't_bill_invest'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.dr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="danger" style="font-weight: bold">
													Total T-Bills Invest
												</b-td>
												<b-td variant="danger" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_t_bill_invest
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td colspan="2" variant="secondary" style="font-weight: bold">
													OTHER PAYMENTS
												</b-td>
											</b-tr>
											<b-tr v-for="(
													value, item
												) in others.data" :key="value.id + 'other_payments'
													" class="list-item">
												<b-td>
													{{ value.name }} - ({{
														value.coabranch?.name
													}})</b-td>
												<b-td>
													GHS
													{{
														displayNumber(
															value
																.coasubheadstransactions?.[0]
																?.dr_balance
														) ?? 0
													}}</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="danger" style="font-weight: bold">
													Total Other Payments
												</b-td>
												<b-td variant="danger" style="font-weight: bold">
													GHS
													{{
														displayNumber(
															total_other_payments
														)
													}}
												</b-td>
											</b-tr>

											<b-tr>
												<b-td variant="secondary" style="font-weight: bold">
													Sub- Total for the Month
												</b-td>
												<b-td variant="secondary" style="font-weight: bold">GHS
													{{
														displayNumber(
															sub_total_payment
														)
													}}</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="secondary" style="font-weight: bold">
													Expenses for the month
												</b-td>
												<b-td variant="secondary" style="font-weight: bold">GHS
													{{
														displayNumber(
															monthly_expenses
														)
													}}</b-td>
											</b-tr>
											<b-tr>
												<b-td variant="secondary" style="font-weight: bold">
													Total Payments
												</b-td>
												<b-td variant="secondary" style="font-weight: bold">GHS
													{{
														displayNumber(
															Number(
																grand_total_payment
															)
														)
													}}</b-td>
											</b-tr>
										</b-tbody>
									</b-table-simple>
								</div>
							</div>
							<div class="row">
								<div class="col-6 col-md-6 p-0 trans_details">
									<b-table-simple responsive outlined bordered>
										<b-tbody>
											<b-tr class="list-item"> </b-tr>
										</b-tbody>
									</b-table-simple>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "../form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			form: {
				start_date: this.getBeginningOfYear(),
				end_date: new Date().toISOString().substr(0, 10),
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "Periodic",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status:[],
			},
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				terms: true,
				coa: false,
				voucher_status: false,
				start_date: true,
				end_date: true,
				loan_status:false,
			},
			incomes: [],
			expenses: [],
			profit_or_loss: 0,
			search: "Search",
			grant_total_expenses: 0,
			grant_total_incomes: 0,
			isBusy: false,
			isSearching: false,
			selected_num: "10",
			numbers_options: [10, 50, 100, 500],
			isLoadingInstitution: false,
			institution: "",
			start_date: "",
			end_date: "",
			member_shares: [],
			member_savings: [],
			member_loans: [],
			member_shares: [],
			member_savings: [],
			member_loans: [],
			bank_savings: [],
			bank_currents: [],
			bank_savings: [],
			bank_currents: [],
			t_bills: [],
			t_bills: [],
			cff: [],
			cff: [],
			others: [],
			others: [],
			total_receipts: 0,
			total_payments: 0,
			total_shares_dp: 0,
			total_savings_dp: 0,
			total_loan_repayment: 0,
			total_shares_with: 0,
			total_savings_with: 0,
			total_loan_disbursed: 0,
			total_bank_savings_wd: 0,
			total_bank_current_wd: 0,
			total_bank_savings_dp: 0,
			total_bank_current_dp: 0,
			total_cff_wd: 0,
			total_t_bill_discount: 0,
			total_other_receipt: 0,
			total_cff_dp: 0,
			total_t_bill_invest: 0,
			total_other_payments: 0,
			monthly_income: 0,
			monthly_expenses: 0,
			sub_total_receipt: 0,
			sub_total_payment: 0,
			// branch_list: [],
			beg_of_month_cash: "",
			grand_total_receipt: 0,
			grand_total_payment: 0,
			// fields: [
			//   {
			//     key: "account_number",
			//     label: "Account Number",
			//   },
			//   {
			//     key: "customer_name",
			//     label: "Customer Name",
			//   },
			//   {
			//     key: "amount",
			//     label: "Amount",
			//   },
			//   {
			//     key: "min_balance",
			//     label: "Minimum Balance",
			//   },
			//   {
			//     key: "total",
			//     label: "Total",
			//   },

			// ],
			perPage: 20,
			currentPage: 1,
			items: [],
		};
	},
	computed: {
		rows() {
			return this.items.length;
		},
		branch_list_display() {
			const selected = this.form.branches || [];
			const all = this.form.branch_options || [];

			if (selected.length > 0) {
				return selected.map(b => b.name).join(", ");
			}
			if (all.length > 0) {
				return all.map(b => b?.name).join(", ");
			}
			return "";
		},
		// sumLoanBalance() {
		//   let total = 0;
		//   for (let i = 0; i < this.items.length; i++) {
		//     total = this.items[i].loan_balance;
		//   }
		//   return total;
		// },
		// sumSavingBalance() {
		//   let total = 0;
		//   for (let i = 0; i < this.items.length; i++) {
		//     total = this.items[i].saving_balance;
		//   }

		//   return total;
		// },
		//assets total
		//   sumAssetsTotal(){
		//     let total = 0;
		//     for(let i = 0; i < this.incomes.length; i++){
		//       total = this.incomes[i].amount;
		//     }
		//     return total;
		//   },
	},

	created() {
		this.getInstitution();
		this.getBalanceSheets();
	},
	methods: {
		async getBalanceSheets() {
			this.items = [];
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			await ApiService.post(
				"/reports/financials/receipts-payments/detailed",
				{
					startDate: this.form.start_date,
					endDate: this.form.end_date,
					terms: this.form.terms,
				}
			)
				.then((response) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					// var res = response.data?.data;
					var res = response.data;
					this.member_shares = res.member_shares;
					this.member_savings = res.member_savings;
					this.member_loans = res.member_loans;
					this.bank_savings = res.bank_savings;
					this.bank_currents = res.bank_currents;
					this.cff = res.cff;
					this.t_bills = res.t_bills;
					this.others = res.others;
					this.monthly_income = res.monthly_income;
					this.monthly_expenses = res.monthly_expenses;
					// this.total_receipts = res.total_receipts;
					// this.total_payments = res.total_payments;
					this.form.branch_options = res.branches;
					this.beg_of_month_cash = res.beg_of_month_cash;
					this.end_of_month_cash = res.end_of_month_cash;

					// this.branch_list = this.form.branches
					// 	.map((branch) => branch.name)
					// 	.join(", ");

					this.sub_total_receipt = Number(
						res.total_receipts
					).toFixed(2);
					this.sub_total_payment = Number(
						res.total_payments
					).toFixed(2);
					this.grand_total_receipt = res.grand_total_receipt;
					this.grand_total_payment = res.grand_total_payment;

					// Calculate the total amount
					this.total_shares_dp = this.member_shares.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.cr_balance ?? 0
								)
							);
						},
						0
					);
					this.total_savings_dp = this.member_savings.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.cr_balance ?? 0
								)
							);
						},
						0
					);
					this.total_loan_repayment =
						this.member_loans.data.reduce((total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.cr_balance ?? 0
								)
							);
						}, 0);

					this.total_bank_savings_wd =
						this.bank_savings.data.reduce((total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.cr_balance ?? 0
								)
							);
						}, 0);
					this.total_bank_current_wd =
						this.bank_currents.data.reduce((total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.cr_balance ?? 0
								)
							);
						}, 0);
					this.total_cff_wd = this.cff.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.cr_balance ?? 0
								)
							);
						},
						0
					);
					this.total_t_bill_discount = this.t_bills.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.cr_balance ?? 0
								)
							);
						},
						0
					);
					this.total_other_receipt = this.others.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.cr_balance ?? 0
								)
							);
						},
						0
					);

					// // Calculate the total amount
					this.total_shares_with = this.member_shares.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.dr_balance ?? 0
								)
							);
						},
						0
					);
					this.total_savings_with =
						this.member_savings.data.reduce((total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.dr_balance ?? 0
								)
							);
						}, 0);
					this.total_loan_disbursed =
						this.member_loans.data.reduce((total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.dr_balance ?? 0
								)
							);
						}, 0);

					this.total_bank_savings_dp =
						this.bank_savings.data.reduce((total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.dr_balance ?? 0
								)
							);
						}, 0);
					this.total_bank_current_dp =
						this.bank_currents.data.reduce((total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.dr_balance ?? 0
								)
							);
						}, 0);
					this.total_cff_dp = this.cff.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.dr_balance ?? 0
								)
							);
						},
						0
					);
					this.total_t_bill_invest = this.t_bills.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.dr_balance ?? 0
								)
							);
						},
						0
					);
					this.total_other_payments = this.others.data.reduce(
						(total, item) => {
							// Access the first element of coasubheadstransactions array and get cr_balance
							return (
								total +
								parseFloat(
									item?.coasubheadstransactions[0]
										?.dr_balance ?? 0
								)
							);
						},
						0
					);

					// Summing the cr_amount values
					// this.total_shares_dp = res.member_shares.data.reduce((sum, item) => {
					//   return sum + parseFloat(item.cr_amount); // Convert cr_amount to float and sum
					// }, 0);
					// this.incomes = res.incomes;
					// this.expenses = res.expenses;
					// this.grant_total_incomes = res.grant_total_incomes;
					// this.grant_total_expenses = res.grant_total_expenses;
					// this.profit_or_loss = this.grant_total_incomes - this.grant_total_expenses;
					// this.start_date = this.form.start_date;
					// this.end_date = this.form.end_date;
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					console.log(error);
				});
		},
		downloadPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},
		filterAction() {
			this.getBalanceSheets();
		},
		printPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		// async generateExcel() {
		// 	const fileUrl = "/REPORT_TEMPLATE.xlsx"; // Path to the file in the public folder

		// 	console.log("Member Shares", this.member_shares);
		// 	console.log("Member Loans", this.member_loans);
		// 	console.log("Member Savings", this.member_savings);
		// 	console.log("Bank Savings", this.bank_savings);
		// 	console.log("Bank Currents", this.bank_currents);
		// 	console.log("CFF", this.cff);
		// 	console.log("T-Bills", this.t_bills);
		// 	console.log("Others", this.others);
		// 	console.log("Monthly Incomes", this.monthly_income);
		// 	console.log("Monthly Expenses", this.monthly_expenses);

		// 	try {
		// 		// Fetch the Excel file from the public URL
		// 		const response = await fetch(fileUrl);
		// 		if (!response.ok) {
		// 			throw new Error(
		// 				`Network response was not ok: ${response.statusText}`
		// 			);
		// 		}
		// 		const arrayBuffer = await response.arrayBuffer();

		// 		// Load the file into ExcelJS
		// 		const wb = new ExcelJS.Workbook();
		// 		await wb.xlsx.load(arrayBuffer);

		// 		// Access the first sheet
		// 		const ws = wb.getWorksheet(1); // Get the first worksheet

		// 		// Define header row
		// 		const header = ["Receipts", "Payments"];

		// 		// Add header row starting from row 13
		// 		const startingRow = 13;
		// 		let headerRow = ws.getRow(startingRow);
		// 		headerRow.values = header;
		// 		headerRow.font = { bold: true };
		// 		headerRow.commit(); // Commit the row to the worksheet

		// 		let col = 1;
		// 		header.forEach((text) => {
		// 			// Merge two columns for each header cell
		// 			ws.mergeCells(startingRow, col, startingRow, col + 1);
		// 			const cell = ws.getCell(startingRow, col);
		// 			cell.value = text;
		// 			cell.font = { bold: true };
		// 			cell.alignment = {
		// 				horizontal: "center",
		// 				vertical: "middle",
		// 			};
		// 			col += 2;
		// 		});

		// 		// Add individual data rows
		// 		let currentRow = startingRow + 1;



		// 		const groupedData = [
		// 			{
		// 				title: "MEMBER SHARES ",
		// 				sub1: "Deposit",
		// 				sub2: "Withdrawals",
		// 				data: this.member_shares,
		// 				detail: {
		// 					name: "Total Share ",
		// 					value1: this.member_shares?.shares_deposit,
		// 					value2: this.member_shares?.shares_withdrawal,
		// 				},
		// 			},
		// 			{
		// 				title: "MEMBER SAVINGS ",
		// 				sub1: "Deposit",
		// 				sub2: "Withdrawals",
		// 				data: this.member_savings,
		// 				detail: {
		// 					name: "Total Savings ",
		// 					value1: this.member_savings?.savings_deposit,
		// 					value2: this.member_savings?.savings_withdrawal,
		// 				},
		// 			},
		// 			{
		// 				title: "LOAN ",
		// 				sub1: "Repayment",
		// 				sub2: "To Members",
		// 				data: this.member_loans,
		// 				detail: {
		// 					name: "Total Loan ",
		// 					value1: this.member_loans?.loans_deposit,
		// 					value2: this.member_loans?.loans_withdrawal,
		// 				},
		// 			},
		// 			{
		// 				title: "BANK SAVINGS ",

		// 				sub1: "Withdrawals",
		// 				sub2: "Deposit",
		// 				data: this.bank_savings,
		// 				detail: {
		// 					name: "Total Bank ",
		// 					value1: this.bank_savings?.bank_savings_deposit,
		// 					value2: this.bank_savings
		// 						?.bank_savings_withdrawal,
		// 				},
		// 			},
		// 			{
		// 				title: "BANK CURRENT ",

		// 				sub1: "Withdrawals",
		// 				sub2: "Deposit",
		// 				data: this.bank_currents,
		// 				detail: {
		// 					name: "Total Bank Current",
		// 					value1: this.bank_currents
		// 						?.bank_current_deposit,
		// 					value2: this.bank_currents
		// 						?.bank_current_withdrawal,
		// 				},
		// 			},
		// 			{
		// 				title: "CUA/CFF ",
		// 				data: this.cff,

		// 				sub1: "Withdrawals",
		// 				sub2: "Deposit",
		// 				detail: {
		// 					name: "Total CFF ",
		// 					value1: this.cff?.cff_deposit,
		// 					value2: this.cff?.cff_withdrawal,
		// 				},
		// 			},
		// 			{
		// 				title: "T-BILL ",
		// 				data: this.t_bills,

		// 				sub1: "Discount",
		// 				sub2: "Invest",
		// 				detail: {
		// 					name: "Total T-Bills ",
		// 					value1: this.t_bills?.t_bill_deposit,
		// 					value2: this.t_bills?.t_bill_withdrawal,
		// 				},
		// 			},
		// 			{
		// 				title: "OTHER ",
		// 				sub1: "Receipt",
		// 				sub2: "Payments",
		// 				data: this.others,
		// 				detail: {
		// 					name: "Total Others",
		// 					value1: this.others?.others_deposit,
		// 					value2: this.others?.others_withdrawal,
		// 				},
		// 			},
		// 		];

		// 		for (const section of groupedData) {
		// 			// ws.mergeCells(currentRow, 1, currentRow, 4);
		// 			// ws.getCell(currentRow, 1).value =
		// 			// 	section.title + " Deposit";
		// 			// ws.getCell(currentRow, 1).value =
		// 			// 	section.title + " Withdrawal";
		// 			// ws.getCell(currentRow, 1).font = { bold: true };

		// 			const row = ws.getRow(currentRow);

		// 			ws.mergeCells(currentRow, 1, currentRow, 2);
		// 			row.getCell(1).value =
		// 				section.title + section.sub1.toLocaleUpperCase();
		// 			row.getCell(1).font = { bold: true };
		// 			ws.mergeCells(currentRow, 3, currentRow, 4);
		// 			row.getCell(3).value =
		// 				section.title + section.sub2.toLocaleUpperCase();
		// 			row.getCell(3).font = { bold: true };
		// 			currentRow++;

		// 			section.data.data?.forEach((item) => {
		// 				if (section.data.data.length > 0) {
		// 					const row = ws.getRow(currentRow);

		// 					row.getCell(1).value =
		// 						`${item.name} - ${item.coabranch.name}` ||
		// 						item.description;
		// 					row.getCell(2).value =
		// 						item.coasubheadstransactions[0]?.dr_balance;
		// 					row.getCell(3).value =
		// 						`${item.name} - ${item.coabranch.name}` ||
		// 						item.description;
		// 					row.getCell(4).value =
		// 						item.coasubheadstransactions[0]?.cr_balance;

		// 					currentRow++;
		// 				}
		// 			});

		// 			const row2 = ws.getRow(currentRow);
		// 			row2.getCell(1).value =
		// 				section.detail.name + section.sub1;
		// 			row2.getCell(1).font = { bold: true };
		// 			row2.getCell(2).value = section.detail.value1;
		// 			row2.getCell(3).value =
		// 				section.detail.name + section.sub2;
		// 			row2.getCell(3).font = { bold: true };
		// 			row2.getCell(4).value = section.detail.value2;

		// 			currentRow += 2;
		// 		}

		// 		// this.incomes.forEach(item => {

		// 		// Map item values to the corresponding header columns
		// 		// row.values = [
		// 		//   item.customer?.first_name + ' ' + item.customer?.last_name,
		// 		//   item.customer.external_code, // Remove extra spaces
		// 		//   item.customer.code,
		// 		//   item.trans_date,
		// 		//   item.transaction_type,
		// 		//   item.account.account_type?.name,
		// 		//   item.trans_amount,
		// 		//   item.code,
		// 		//   item.affected_coa,
		// 		// ];

		// 		// });
		// 		const buffer = await wb.xlsx.writeBuffer();
		// 		const blob = new Blob([buffer], {
		// 			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		// 		});

		// 		// Create a download link and simulate a click to download the file
		// 		const link = document.createElement("a");
		// 		link.href = URL.createObjectURL(blob);
		// 		link.download = "note_to_payment_and_receipts.xlsx";
		// 		document.body.appendChild(link);
		// 		link.click();
		// 		document.body.removeChild(link);
		// 	} catch (err) {
		// 		console.error(
		// 			"Error fetching, modifying, or downloading the Excel file:",
		// 			err.message
		// 		);
		// 	}
		// },
		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;
			const date =
				"FROM: " +
				this.form.start_date +
				" TO: " +
				this.form.end_date;
			const terms = "TERMS:  " + this.form.terms;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`L${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`L${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				}; // Bold and bigger font for name

				ws.getCell(`L${institutionDetailsRow + 1}`).value =
					institutionAddress;
				ws.getCell(`L${institutionDetailsRow + 1}`).font = {
					size: 12,
				}; // Regular font size for address

				ws.getCell(`L${institutionDetailsRow + 2}`).value =
					institutionMotto;
				ws.getCell(`L${institutionDetailsRow + 2}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`L${institutionDetailsRow + 3}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`L${institutionDetailsRow + 4}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 6}`).value = date;
				ws.getCell(`L${institutionDetailsRow + 6}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`L${institutionDetailsRow + 7}`).value = terms;
				ws.getCell(`L${institutionDetailsRow + 7}`).font = {
					size: 12,
				}; // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn("L").width = 50; // Adjust the width of column L (if necessary)

				// Define header row
				const header = ["RECEIPTS", "", "PAYMENTS", ""];

				// Add header row starting from row 13
				const startingRow = 13;
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Merge cells for headers
				ws.mergeCells(startingRow, 1, startingRow, 2);
				ws.mergeCells(startingRow, 3, startingRow, 4);

				const receiptCell = ws.getCell(startingRow, 1);
				receiptCell.value = "RECEIPTS";
				receiptCell.font = { bold: true };
				receiptCell.alignment = { horizontal: "center", vertical: "middle" };

				const paymentCell = ws.getCell(startingRow, 3);
				paymentCell.value = "PAYMENTS";
				paymentCell.font = { bold: true };
				paymentCell.alignment = { horizontal: "center", vertical: "middle" };

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Add beginning of month cash
				const beginRow = ws.getRow(currentRow);
				beginRow.getCell(1).value = "Beg. of the month cash";
				beginRow.getCell(2).value = `GHS ${this.displayNumber(Number(this.beg_of_month_cash).toFixed(2))}`;
				beginRow.getCell(3).value = "End. of the month cash";
				beginRow.getCell(4).value = `GHS ${this.displayNumber(Number(this.end_of_month_cash).toFixed(2))}`;
				currentRow++;

				const groupedData = [
					{
						title: "MEMBER SHARES",
						receiptTitle: "MEMBER SHARES DEPOSIT",
						paymentTitle: "MEMBER SHARES WITHDRAWALS",
						data: this.member_shares,
						receiptTotal: "Total Shares Deposit",
						paymentTotal: "Total Shares Withdrawals",
						receiptTotalValue: this.total_shares_dp,
						paymentTotalValue: this.total_shares_with,
					},
					{
						title: "MEMBER SAVINGS",
						receiptTitle: "MEMBER SAVINGS DEPOSIT",
						paymentTitle: "MEMBER SAVING WITHDRAWALS",
						data: this.member_savings,
						receiptTotal: "Total Savings Deposit",
						paymentTotal: "Total Savings Withdrawals",
						receiptTotalValue: this.total_savings_dp,
						paymentTotalValue: this.total_savings_with,
					},
					{
						title: "LOAN",
						receiptTitle: "LOAN REPAYMENT",
						paymentTitle: "LOANS TO MEMBERS",
						data: this.member_loans,
						receiptTotal: "Total Loan Repayment",
						paymentTotal: "Total Loans to members",
						receiptTotalValue: this.total_loan_repayment,
						paymentTotalValue: this.total_loan_disbursed,
					},
					{
						title: "BANK SAVINGS",
						receiptTitle: "BANK SAVINGS WITHDRWALS",
						paymentTitle: "BANK SAVINGS DEPOSIT",
						data: this.bank_savings,
						receiptTotal: "Total Bank Savings Withdrawals",
						paymentTotal: "Total Bank Saving",
						receiptTotalValue: this.total_bank_savings_wd,
						paymentTotalValue: this.total_bank_savings_dp,
					},
					{
						title: "BANK CURRENT",
						receiptTitle: "BANK CURRENT WITHDRWALS",
						paymentTitle: "BANK CURRENT DEPOSIT",
						data: this.bank_currents,
						receiptTotal: "Total Bank Current Withdrawals",
						paymentTotal: "Total Bank Current",
						receiptTotalValue: this.total_bank_current_wd,
						paymentTotalValue: this.total_bank_current_dp,
					},
					{
						title: "CUA/CFF",
						receiptTitle: "CUA/CFF/ WITHDRAWALS",
						paymentTitle: "CUA/CFF DEPOSITS",
						data: this.cff,
						receiptTotal: "Total CUA/CFF Withdrawals",
						paymentTotal: "Total CUA/CFF Deposit",
						receiptTotalValue: this.total_cff_wd,
						paymentTotalValue: this.total_cff_dp,
					},
					{
						title: "T-BILLS",
						receiptTitle: "T-BILLS DISCOUNT",
						paymentTitle: "T-BILLS INVEST",
						data: this.t_bills,
						receiptTotal: "Total T-Bill Discount",
						paymentTotal: "Total T-Bills Invest",
						receiptTotalValue: this.total_t_bill_discount,
						paymentTotalValue: this.total_t_bill_invest,
					},
					{
						title: "OTHER",
						receiptTitle: "OTHER RECEIPTS",
						paymentTitle: "OTHER PAYMENTS",
						data: this.others,
						receiptTotal: "Total Other Receipts",
						paymentTotal: "Total Other Payments",
						receiptTotalValue: this.total_other_receipt,
						paymentTotalValue: this.total_other_payments,
					},
				];

				for (const section of groupedData) {
					// Add section headers
					const sectionHeaderRow = ws.getRow(currentRow);
					ws.mergeCells(currentRow, 1, currentRow, 2);
					ws.mergeCells(currentRow, 3, currentRow, 4);

					sectionHeaderRow.getCell(1).value = section.receiptTitle;
					sectionHeaderRow.getCell(1).font = { bold: true };
					sectionHeaderRow.getCell(3).value = section.paymentTitle;
					sectionHeaderRow.getCell(3).font = { bold: true };
					currentRow++;

					// Find the maximum number of items to iterate through both sides
					const maxItems = Math.max(
						section.data.data?.length || 0,
						section.data.data?.length || 0
					);

					// Add data rows
					for (let i = 0; i < maxItems; i++) {
						const dataRow = ws.getRow(currentRow);

						if (i < section.data.data?.length) {
							const item = section.data.data[i];
							// Receipt side (cr_balance)
							dataRow.getCell(1).value = `${item.name} - (${item.coabranch?.name})`;
							dataRow.getCell(2).value = `GHS ${this.displayNumber(item.coasubheadstransactions?.[0]?.cr_balance) || 0}`;

							// Payment side (dr_balance)
							dataRow.getCell(3).value = `${item.name} - (${item.coabranch?.name})`;
							dataRow.getCell(4).value = `GHS ${this.displayNumber(item.coasubheadstransactions?.[0]?.dr_balance) || 0}`;
						}
						currentRow++;
					}

					// Add totals row
					const totalRow = ws.getRow(currentRow);
					totalRow.getCell(1).value = section.receiptTotal;
					totalRow.getCell(1).font = { bold: true };
					totalRow.getCell(2).value = `GHS ${this.displayNumber(section.receiptTotalValue)}`;
					totalRow.getCell(2).font = { bold: true };
					totalRow.getCell(3).value = section.paymentTotal;
					totalRow.getCell(3).font = { bold: true };
					totalRow.getCell(4).value = `GHS ${this.displayNumber(section.paymentTotalValue)}`;
					totalRow.getCell(4).font = { bold: true };
					currentRow += 2; // Add extra space between sections
				}

				// Add summary rows
				const summaryRows = [
					{
						receiptLabel: "Sub- Total for the Month",
						receiptValue: this.sub_total_receipt,
						paymentLabel: "Sub- Total for the Month",
						paymentValue: this.sub_total_payment,
					},
					{
						receiptLabel: "Income for the month",
						receiptValue: this.monthly_income,
						paymentLabel: "Expenses for the month",
						paymentValue: this.monthly_expenses,
					},
					{
						receiptLabel: "Total Receipts",
						receiptValue: this.grand_total_receipt,
						paymentLabel: "Total Payments",
						paymentValue: this.grand_total_payment,
					},
				];

				summaryRows.forEach(summary => {
					const summaryRow = ws.getRow(currentRow);
					summaryRow.getCell(1).value = summary.receiptLabel;
					summaryRow.getCell(1).font = { bold: true };
					summaryRow.getCell(2).value = `GHS ${this.displayNumber(Number(summary.receiptValue))}`;
					summaryRow.getCell(2).font = { bold: true };
					summaryRow.getCell(3).value = summary.paymentLabel;
					summaryRow.getCell(3).font = { bold: true };
					summaryRow.getCell(4).value = `GHS ${this.displayNumber(Number(summary.paymentValue))}`;
					summaryRow.getCell(4).font = { bold: true };
					currentRow++;
				});

				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "note_to_payment_and_receipts.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},
	},
};
</script>
